import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';

Vue.use(Router);


export default new Router({
  mode: 'history',
  base: '/',
  // scrollBehavior(to, from, savedPosition) {
  //   // https://router.vuejs.org/ru/guide/advanced/scroll-behavior.html#%D0%B0%D1%81%D0%B8%D0%BD%D1%85%D1%80%D0%BE%D0%BD%D0%BD%D0%B0%D1%8F-%D0%BF%D1%80%D0%BE%D0%BA%D1%80%D1%83%D1%82%D0%BA%D0%B0
  //   if (to.hash) { // Эмулируем переход к якорю. Тоесть если в ссылку добавить в конце хеш '#my-custom-cool-id', то страница автоматически прокрутится к этому элементу
  //     return {
  //       selector: to.hash,
  //     };
  //   }
  //   if (to.meta.handleScrollInComponent) return null;
  //   return savedPosition;
  // },
  routes,
});
